// import Accordion from '../../plugins/accordion.js';
// const elements = document.querySelectorAll(".js-accordion");
// for (const element of elements) {
//   let accordion = new Accordion(element, {
//     multipleOpen: true,
//     defaultOpenPanels: [0],
//     onOpen: (trigger, panel) => {},
//     onClose: (trigger, panel) => {}
//   });
// }

// アコーディオン
document.querySelectorAll('.c-acc-ttl').forEach(summary => {
    summary.addEventListener('click', (e) => {
        e.preventDefault();
        
        const details = summary.closest('.c-acc');
        const content = details.querySelector('.c-acc-cont');
  
        if (details.open) {
            // 閉じる
            const startHeight = content.offsetHeight;
            content.style.height = startHeight + 'px';
            content.style.opacity = '1';
            
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    content.style.height = '0px';
                    content.style.opacity = '0';
                });
            });
  
            setTimeout(() => {
                details.open = false;
                content.style.height = '';
                content.style.opacity = '';
            }, 300); // CSSのtransition(.3s)
  
        } else {
            // 開く処理
            details.open = true;
            const targetHeight = content.scrollHeight;
            
            content.style.height = '0px';
            content.style.opacity = '0';
  
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    content.style.height = targetHeight + 'px';
                    content.style.opacity = '1';
                });
            });
  
            setTimeout(() => {
                content.style.height = 'auto';
            }, 300); // CSSのtransition(.3s)
        }
    });
  });

// accordion.destroy()
// accordion.init()
